<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="create_new_p2_import_proc" ttGoto="p2importproc" [ttGotoParms]="{ p2_importproc_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListImportProcedures"></tt-list>
</tt-page>
